import { createFileRoute, redirect } from "@tanstack/react-router";
import { AuthorizedRouteContext } from "@/routes/_authorized/route";
import { checkUserPermissions } from "@/features/auth";
import { EditTeammate } from "@/features/teammates/routes/edit";

const Route = createFileRoute("/_authorized/teammates/$teammateId/edit/")({
  beforeLoad: async ({ context }) => {
    const { userDetails } = context as AuthorizedRouteContext;

    const isUserPermitted = checkUserPermissions(userDetails, ["TEAMMATE_EDIT"]);

    if (!isUserPermitted) {
      redirect({
        to: "/teammates",
        replace: true,
        throw: true,
      });
    }
  },
  component: () => <EditTeammate />,
});

export { Route };
